import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EXTERNAL_REDIRECT_BY_PATH } from "./external-redirect-urls";

@Component({
  selector: "app-external-redirect",
  template: "",
  standalone: false,
})
export class ExternalRedirectComponent {
  constructor(private route: ActivatedRoute) {
    const path = this.route.snapshot.routeConfig?.path ?? "";
    const url = EXTERNAL_REDIRECT_BY_PATH[path];
    if (url) {
      window.location.replace(url);
    }
  }
}
